import React from 'react';
import { Route, IndexRoute } from 'react-router';
import DealsContainerResolver from 'split-chunk-loader?lazy!../Promotion/DealsContainerResolver';
import DealsTagListContainer from 'split-chunk-loader?lazy!../Promotion/DealsTagListContainer';
import { lazify } from '../Common/Helper';

const metadata = {
  title: 'Deal',
  metaDescription: 'The Right Deals and Discounts by {storeName}',
};

const PromotionGroupRoute = (
  <Route label="Deal" path="(:id/)deal/:slug">
    <IndexRoute label="Deal" helmet={metadata} component={lazify(DealsContainerResolver)}/>
    <Route label="Deal" helmet={metadata} path=":tag" component={lazify(DealsTagListContainer)}/>
  </Route>
);

export default PromotionGroupRoute;



// WEBPACK FOOTER //
// ./src/Routes/Deal.js